import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Header from "component/Header/Header";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TableVales from "component/TableVales/TableVales";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import { getSaldo, getEmpresasByCuentaContrato } from "component/api";
import AlertSaldoNegativo from "component/AlertSaldoNegativo/AlertSaldoNegativo";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "valespage",
  },
  dataLayerName: "Vales",
};

const Vales = (props) => {
  TagManager.dataLayer(tagManagerArgs);

  const [saldo, setSaldo] = useState("");
  const cuentaContrato = localStorage.getItem("cuentaContrato");
  var empresa = [];
  //const empresaNombre = "";
  const [empresaEmail, setEmpresaEmail] = useState("");
  const [empresaDomicilio, setEmpresaDomicilio] = useState("");

  async function getEmpresasByCuentaContratoFunc(cc) {
    const res = await getEmpresasByCuentaContrato(cc);
    console.log(res);
    empresa = res.data;

    localStorage.setItem("empresaNombre", empresa.razonSocial);
    //setEmpresaId(empresa.id);
    localStorage.setItem("empresaId", empresa.id);
    setEmpresaEmail(empresa.correoElectronico);
    setEmpresaDomicilio(empresa.localidad + " " + empresa.direccion);
  }

  useEffect(() => {
    try {
      localStorage.removeItem("idvale");
      getEmpresasByCuentaContratoFunc(cuentaContrato);
      getSaldoFunc(cuentaContrato);
    } catch (err) {} // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentaContrato]);

  async function getSaldoFunc(nroCuenta) {
    const res = await getSaldo(nroCuenta);
    setSaldo(res.data);
  }
  const logeado = sessionStorage.getItem("logeado");
  const [table, setTable] = React.useState(false);
  const [hide, setHide] = React.useState(false);
  function button() {
    setTable(true);
    setHide(true);
  }
  function hideButton() {
    setTable(false);
    setHide(false);
  }
  const buttonSalir = (
    <Link to="/" style={{ textDecoration: "none", alignSelf: "center" }}>
      <Button
        variant="contained"
        style={{
          width: "50%",

          textTransform: "none",

          backgroundColor: "#F86436",
          color: "white",
        }}
        onClick={() => {
          localStorage.clear();
          sessionStorage.clear();
        }}
      >
        {" "}
        Salir
      </Button>
    </Link>
  );
  const valep = (
    <div>
      <Header button={buttonSalir} />
      {logeado === "true" && (
        <div>
          <Container maxWidth="md">
            <br />
            <p>
              NOMBRE Y APELLIDO/EMPRESA: {localStorage.getItem("empresaNombre")}
              <br />
              NÚMERO DE CUENTA: {cuentaContrato}
              <br />
              E-MAIL: {empresaEmail}
              <br />
              DOMICILIO: {empresaDomicilio}
            </p>
            <Divider />
            <div>
              <p style={{ fontSize: "28px", marginBottom: "0%" }}>
                Vales de descarga disponibles
              </p>
              Seleccioná el vale de descarga que quieras utilizar
            </div>
            <div style={{ backgroundColor: "rgba(192,192,192,0.3)" }}>
              <p
                style={{
                  paddingTop: "2%",
                  paddingBottom: "2%",
                  paddingLeft: "90%",
                }}
              >
                Saldo
              </p>
            </div>
            <form>
              <div>
                <Grid container sx={{ width: "100%" }}>
                  <Grid size={{ xs: 10 }}>
                    {" "}
                    {saldo &&
                      saldo
                        .filter((cam) => cam.tipoVale.id == 1)
                        .map((campaña, index) => (
                          <div key={campaña.tipoVale?.id ?? index}>
                            {campaña.cantidadValesTotales <=
                            campaña.topeSaldo ? (
                              <AlertSaldoNegativo
                                valesCont={true}
                                button={true}
                                errorSymp={true}
                                valeType={1}
                                color={"#009BDB"}
                                texto={"Generar Vale hasta 12 m3"}
                                tope={campaña.topeSaldo}
                                cantidad={campaña.cantidadValesTotales}
                              />
                            ) : (
                              <Link
                                to="/vale"
                                style={{
                                  textDecoration: "none",
                                  alignSelf: "center",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "#009BDB",
                                    color: "white",
                                    width: "100%",
                                    marginBottom: "1%",
                                    marginTop: "1%",
                                    textTransform: "none",
                                    margingRight: "90%",
                                  }}
                                  //type="submit"
                                  onClick={() => {
                                    localStorage.setItem("valeType", 1);
                                  }}
                                >
                                  Generar Vale hasta 12 m3
                                </Button>
                              </Link>
                            )}
                          </div>
                        ))}
                  </Grid>
                  <Grid size="grow">
                    {" "}
                    <div
                      style={{
                        marginLeft: "50%",
                        marginTop: "5%",
                        // color: setColorSaldo(),
                      }}
                    >
                      {saldo &&
                        saldo
                          .filter((cam) => cam.tipoVale.id == 1)
                          .map((campaña, index) => (
                            <div key={`saldo-1-${index}`}>
                              <p
                                style={{
                                  color:
                                    campaña.cantidadValesTotales > 0
                                      ? "black"
                                      : "red",
                                  marginLeft:
                                    campaña.cantidadValesTotales > 0
                                      ? "8%"
                                      : "0%",
                                }}
                              >
                                {campaña.cantidadValesTotales}
                              </p>
                            </div>
                          ))}
                    </div>
                  </Grid>
                </Grid>

                <Divider />
                <Grid container sx={{ width: "100%" }}>
                  <Grid size={{ xs: 10 }}>
                    {" "}
                    {saldo &&
                      saldo
                        .filter((cam) => cam.tipoVale.id == 2)
                        .map((campaña, index) => (
                          <div key={campaña.tipoVale?.id ?? `2-${index}`}>
                            {campaña.cantidadValesTotales < 0 ? (
                              <AlertSaldoNegativo
                                valesCont={true}
                                button={true}
                                errorSymp={true}
                                valeType={2}
                                color={"rgb(128,0,128)"}
                                texto={"Generar Vale de 13 hasta 20 m3"}
                                tope={campaña.topeSaldo}
                                cantidad={campaña.cantidadValesTotales}
                              />
                            ) : (
                              <Link
                                to="/vale"
                                style={{
                                  textDecoration: "none",
                                  alignSelf: "center",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "rgb(128,0,128)",
                                    color: "white",
                                    width: "100%",
                                    marginBottom: "1%",
                                    marginTop: "1%",
                                    textTransform: "none",
                                    margingRight: "90%",
                                  }}
                                  //type="submit"
                                  onClick={() => {
                                    localStorage.setItem("valeType", 2);
                                  }}
                                >
                                  Generar Vale de 13 hasta 20 m3
                                </Button>
                              </Link>
                            )}
                          </div>
                        ))}
                  </Grid>
                  <Grid size="grow">
                    <div
                      style={{
                        marginLeft: "50%",
                        marginTop: "10%",
                        // color: setColorSaldo(),
                      }}
                    >
                      {saldo &&
                        saldo
                          .filter((cam) => cam.tipoVale.id == 2)
                          .map((campaña, index) => (
                            <p
                              key={`saldo-2-${index}`}
                              style={{
                                color:
                                  campaña.cantidadValesTotales > 0
                                    ? "black"
                                    : "red",
                                marginLeft:
                                  campaña.cantidadValesTotales > 0
                                    ? "8%"
                                    : "0%",
                              }}
                            >
                              {campaña.cantidadValesTotales}
                            </p>
                          ))}
                    </div>
                  </Grid>
                </Grid>

                <Divider />
                <Grid container sx={{ width: "100%" }}>
                  <Grid size={{ xs: 10 }}>
                    {" "}
                    {saldo &&
                      saldo
                        .filter((cam) => cam.tipoVale.id == 3)
                        .map((campaña, index) => (
                          <div key={campaña.tipoVale?.id ?? `3-${index}`}>
                            {campaña.cantidadValesTotales < 0 ? (
                              <AlertSaldoNegativo
                                valesCont={true}
                                button={true}
                                errorSymp={true}
                                valeType={3}
                                color={"red"}
                                texto={"Generar Vale de 21 hasta 36 m3"}
                                tope={campaña.topeSaldo}
                                cantidad={campaña.cantidadValesTotales}
                              />
                            ) : (
                              <Link
                                to="/vale"
                                style={{
                                  textDecoration: "none",
                                  alignSelf: "center",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    width: "100%",
                                    marginBottom: "1%",
                                    marginTop: "1%",
                                    textTransform: "none",
                                    margingRight: "90%",
                                  }}
                                  //type="submit"
                                  onClick={() => {
                                    localStorage.setItem("valeType", 3);
                                  }}
                                >
                                  Generar Vale de 21 hasta 36 m3
                                </Button>
                              </Link>
                            )}
                          </div>
                        ))}
                  </Grid>
                  <Grid size="grow">
                    <div
                      style={{
                        marginLeft: "50%",
                        marginTop: "10%",
                        //color: setColorSaldo(),
                      }}
                    >
                      {saldo &&
                        saldo
                          .filter((cam) => cam.tipoVale.id == 3)
                          .map((campaña, index) => (
                            <p
                              key={`saldo-3-${index}`}
                              style={{
                                color:
                                  campaña.cantidadValesTotales > 0
                                    ? "black"
                                    : "red",
                                marginLeft:
                                  campaña.cantidadValesTotales > 0
                                    ? "8%"
                                    : "0%",
                              }}
                            >
                              {campaña.cantidadValesTotales}
                            </p>
                          ))}
                    </div>
                  </Grid>
                </Grid>

                <Divider />
              </div>
            </form>

            {table === true ? (
              <TableVales />
            ) : (
              <Button
                variant="contained"
                onClick={() => button()}
                endIcon={<ArrowDropDownIcon />}
                style={{
                  width: "100%",
                  marginBottom: "1%",
                  textTransform: "none",
                  padding: "1%",
                  marginTop: "4%",
                  backgroundColor: "blue",
                  color: "white",
                }}
              >
                Ver últimos movimientos de Vales
              </Button>
            )}
            {hide === true && (
              <Button
                variant="contained"
                onClick={() => hideButton()}
                endIcon={<ArrowDropUpIcon />}
                style={{
                  width: "100%",
                  marginBottom: "1%",
                  textTransform: "none",

                  backgroundColor: "blue",
                  color: "white",
                }}
              ></Button>
            )}
          </Container>
        </div>
      )}
      {logeado === null && (
        <div style={{ marginLeft: "10%", marginTop: "4%" }}>
          <h2>Por favor iniciar la sesión .</h2>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div>{valep}</div>
    </div>
  );
};
export default Vales;
